import type { RouteRecordRaw } from 'vue-router'

const rootlayoutRoutes: RouteRecordRaw[] = [
  {
    path: 'tt',
    name: 'testPage',
    component: () => import('@/pages/test/TestPage.vue'),
  },
]

export const v1LayoutRoutes = [...rootlayoutRoutes]
